export default __webpack_public_path__ + "static/evin-4e2986ebd834b27ab78a2ec6f2ec90fd.jpg";